module.exports = __webpack_public_path__ + "static/media/learning-1.9082c2df.png";